import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import { IBugReportType } from '../../../../types/interfaces/bug-report-type';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (property: IBugReportType) => void,
  onDelete: (property: IBugReportType) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME,
      cellReducer: (type: IBugReportType) => {
        return <div className={classes.name}>{type.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      cellReducer: (type: IBugReportType) => {
        return <div className={classes.nameKey}>{type.nameKey}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.PRIORITY,
      cellReducer: (type: IBugReportType) => {
        return <div className={classes.priority}>{type.priority}</div>;
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (property: IBugReportType) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(property);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(property);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
